<template>
	<vs-dialog prevent-close v-model="active" @close="borrarInfo">
		<template #header>
			<h4 class="not-margin">
				Registrar pago {{ tipo && tipo == 'abierto' ? 'abierto' : tipo == 'cargo-abono' ? 'desde regla de cobro' : tipo == 'servicio' ? 'desde servicio' : '' }}
			</h4>
		</template>


		<div class="con-form">
			<vs-row>
				<vs-col vs-justify="center" vs-align="center" xs="12" lg="6">
					<label for="fecha" class="labelInput">
						Fecha 
					</label>
					<vs-input
					:disabled="bloquear == true"
					class="pt-0"
					type="date"
					v-model="fecha"
					required="required"
					id="fecha"
					name="fecha"
					@change="getConcepto()">
						<template #message-danger v-if="errorFields.includes('fecha')">
							Requerido
						</template>
					</vs-input>
				</vs-col>
				<vs-col vs-justify="center" vs-align="center"  xs="12" lg="6">
					<form autocomplete="off" v-if="tipo === 'abierto'">
						<label for="monto" class="labelInput">
							Monto
						</label>
						<vs-input
						class="pt-0"
						type="number"
						v-model="monto"
						required="required"
						id="monto"
						@input="roundDecimals('monto')"
						name="monto">
							<template #message-danger v-if="errorFields.includes('monto')">
								Requerido
							</template>
						</vs-input>
					</form>
					<h4 v-else class="text-center" style="margin: 6% 0 0 0;">
						<span v-if="concepto !== ''"> $ {{monto}}</span>
					</h4>
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col class="mt-3" vs-justify="center" vs-align="center" xs="12" lg="12">
					<vs-select :filter="Boolean(listPrograma.length > 1)" label-placeholder="Programa" v-model="programa" :key="programaId" :disabled="!Boolean(listPrograma.length > 1)" ref="content" @change="getConcepto()" >

						<template #message-danger v-if="errorFields.includes('programa')">
							Requerido
						</template>
						<template v-if="listPrograma.length">
							<vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
								{{option.text}}
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
							</vs-option>
						</template>
					</vs-select>
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col vs-justify="center" vs-align="center" w="12">
					<form autocomplete="off">
						<label for="fecha" class="labelInput">
							No. de autorización
						</label>
						<vs-input
						:disabled="bloquear == true"
						class="pt-0"
						v-model="autorizacion"
						required="required"
						id="fecha"
						name="fecha">
							<template #message-danger v-if="errorFields.includes('autorizacion')">
								Requerido
							</template>
						</vs-input>
					</form>
				</vs-col>
			</vs-row>
			<vs-row>
				<form autocomplete="off" style="width:100%;">
					<vs-select class="marginTop" id="metodo-pago-registrar-pagos" filter label-placeholder="Método de pago"  
						v-model="metodoPago"  :key="metodoPagoId" :disabled="!listMetodoPago.length || bloquear == true">
						<template #message-danger v-if="errorFields.includes('metodoPago')">
							Requerido
						</template>
						<template v-if="listMetodoPago.length">
							<vs-option v-for="option in listMetodoPago" :key="option.id"  :label="option.text" :value="option.id">
								{{option.text}}
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
							</vs-option>
						</template>
					</vs-select>
				</form>
			</vs-row>
			<vs-row>
				<form autocomplete="off" style="width:100%;">
					<vs-select id="conceptos-registrar-pagos" :loading="loadingConceptos" class="mt-3" filter label-placeholder="Concepto" v-model="concepto"  :key="conceptoId" :disabled="!listConceptos.length">
						<template #message-danger v-if="errorFields.includes('concepto') || noConceptos">
							{{ errorFields.includes('concepto') ? 'Requerido' : noConceptos == true ? 'Para este Ciclo escolar no hay reglas de cobro configuradas' : ''}}
						</template>
						<template v-if="listConceptos.length">
							<vs-option v-for="option in listConceptos" :key="option.id" :label="option.nombre" :value="option.id">
								{{option.nombre}} <span v-if="tipo != 'abierto'">- $ {{option.monto_cargo}}</span>
							</vs-option>
						</template>
						<template v-else>
							<vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
							</vs-option>
						</template>
					</vs-select>
				</form>
			</vs-row>
			<vs-row>
				<vs-col xs="6" lg="3">
					<vs-switch v-if="tipo === 'abierto'" style="margin: 14px 0px 0px 12px;" v-model="descuento">
						Descuento
					</vs-switch>
				</vs-col>
				<vs-col class="marginTop" vs-justify="center" vs-align="center"  xs="12" lg="8">
					<form autocomplete="off">
						<vs-select id="conceptos-descuentos-registrar-pagos" v-if="descuento" filter label-placeholder="Concepto Descuento" v-model="conceptoDescuento"  :key="conceptoDescuentoId" :disabled="!listDescuento.length">
							<template #message-danger v-if="errorFields.includes('conceptoDescuento')">
								Requerido
							</template>
							<template v-if="listDescuento.length">
								<vs-option v-for="option in listDescuento" :key="option.id"  :label="option.nombre" :value="option.id">
									{{option.nombre}}
								</vs-option>
							</template>
							<template v-else>
								<vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
								</vs-option>
							</template>
						</vs-select>
					</form>
				</vs-col>
			</vs-row>
			<vs-row>
				<vs-col v-if="descuento" vs-justify="center" vs-align="center" w="12">
					<form autocomplete="off">
						<label for="monto" class="labelInput">
							Monto 
						</label>
						<vs-input
						class="pt-0"
						type="number"
						v-model="montoDescuento"
						required="required"
						@input="roundDecimals('montoDescuento')"
						id="montoDescuento"
						name="montoDescuento">
							<template #message-danger v-if="errorFields.includes('montoDescuento')">
								Requerido
							</template>
						</vs-input>
					</form>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2 mb-2">
				<vs-button block class="color-blue" @click="encolarPagos">
					Agregar Pago  
				</vs-button>           
			</vs-row>
		</div>
		<template #footer>
			<div v-if="queuePagos.length" class="footer-dialog" style="max-width: 432px;">
				<vs-row class="mb-3">
					<vs-col>
						<h5>PAGOS</h5>
					</vs-col>
					<vs-col class="dividerLine" v-for="(pago, i) in queuePagos" :key="i">
						<vs-row class="mt-3" style="display: flex; justify-content: center; align-items: center;">
							<vs-col xs="12" lg="2" class="textRight">
								<i @click="removerPago(i)" class="fas fa-times dangerColor"></i>
							</vs-col>
							<vs-col xs="12" lg="10">
								<vs-row>
									<vs-col xs="12" lg="6">
										<div v-if="pago.concepto != ''" class="mb-3">
											<p class="mb-0 greyOscuro">{{pago.codigo_detalle_name}}</p>
											<small class="greyColor">Concepto</small>
										</div>
										<div v-if="pago.fecha">
											<p class="greyOscuro mb-0 mt-3"><i class="far fa-calendar-alt mr-2"></i>{{pago.fecha}}</p>
											<small class="greyColor">Fecha</small>
										</div>
										<div v-if="pago.num_autorizacion">
											<p class="mb-0 mt-2 greyOscuro"><strong>{{pago.num_autorizacion}}</strong></p>
											<p class="mb-3"><small class="greyColor">No. de Autorización</small></p>
										</div>
										<div v-if="pago.metodo_de_pago != ''">
											<p class="mb-0 greyOscuro" style="overflow-wrap: break-word;">{{pago.metodo_pago_name}}</p>
											<p class="mb-3"><small class="greyColor">Método de pago</small></p>
										</div>
									</vs-col>
									<vs-col class="textRightDesktop" xs="12" lg="6">
										<div v-if="pago.monto">
											<h5 class="mb-0"><span class="greyOscuro"><strong>$ {{pago.monto}}</strong></span></h5>
											<p class="mb-3"><small class="greyColor" style="font-size: 12.8px">Monto</small></p>
										</div>
										<div class="mb-2" v-if="pago && pago.descuentos && pago.descuentos.monto">
											<p class="mb-0 mt-2 greyOscuro" style="font-size: 16px !important"><strong>{{pago.descuentos.monto}}</strong></p>
											<small class="greyColor">Descuento</small>
										</div>
										<div v-if="pago.descuento">
											<p class="mb-0 greyOscuro"><span>{{pago.descuento}}</span></p>
											<small class="greyColor">Concepto de descuento</small>
										</div>
									</vs-col>
								</vs-row>
							</vs-col>
						</vs-row>
					</vs-col>
				</vs-row>
				<vs-col>
					<div class="mb-2 text-right" v-if="descuentoPrice > 0">
						<p class="mb-0 mt-3 greyOscuro" style="font-size: 16px !important"><strong>{{descuentoPrice}}</strong></p>
						<small class="greyColor">Descuento</small>
						<h4 class="mb-0 text-right"><span class="greyOscuro"><strong>$ {{subtotal}}</strong></span></h4>
						<p class="mb-3 mt-2 text-right"><small class="greyColor" style="font-size: 12.8px">Total</small></p>
					</div>
					<div v-else>
						<h4 class="mb-0 text-right"><span class="greyOscuro"><strong>$ {{subtotal}}</strong></span></h4>
						<p class="mb-3 text-right"><small class="greyColor" style="font-size: 12.8px">Total</small></p>
					</div>
				</vs-col>
				<vs-button block class="color-blue" @click="aplicarPagos">
					Guardar  
				</vs-button> 
			</div>
		</template>	
	</vs-dialog>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
import cobranza from '../../../../api/requests/cobranza-persona.js'


export default {
	props:[
	'value',
	'row',
	'personaId',
	'cicloEscolar',
	'institucion',
	'tipo',
	'nivel',
	'nivelId',
	'listNivel',
	'programaId',
	'listPrograma',
	'programaDefault'

	],
	data () {
		return {
			active: false,
			descuento: false,
			conceptoDescuento: '',
			fecha: null,
			monto: null,
			montoDescuento: null,
			comentarios: null,
			autorizacion: null,
			metodoPagoId: (new Date()).getTime(),
			conceptoId: (new Date()).getTime(),
			conceptoDescuentoId: (new Date()).getTime(),
			metodoPago: '',
			concepto: '',
			listMetodoPago :[],
			listConceptos: [],
			loadingConceptos: false,
			noConceptos : false,
			listDescuento: [],
			errorFields: [],
			queuePagos:[],
			metodosPago: [],
			subtotal: '',
			total: '',
			descuentoPrice: '',
			programa: '',
			bloquear: false
		}
	},
	methods: {
		getDecimal() {

		},
		getSuma (dato){
			const vm = this
			let subtotal = 0;
			let descuento = 0;
			dato.forEach(i => {
				subtotal += i.monto
				descuento += i.descuentos.monto
			})
			vm.descuentoPrice = descuento
			vm.subtotal = subtotal
		},
		
		async roundDecimals (e, decimals = 2) {
			this[e] = parseFloat(parseFloat(this[e]).toFixed(decimals))
		},
		async encolarPagos() {
			this.errorFields = this.sanityForm(this.tipo)
			const vm = this
			if (!this.errorFields.length) {
				if(this.autorizacion !== ''){
					this.bloquear = true
				}
				let data = {
					fecha: this.fecha,
					descuento: this.descuentoSelect,
					num_autorizacion: this.autorizacion,
					persona: this.personaId, 
					ciclo_escolar : this.cicloEscolar, 
					institucion : this.institucion,
					nivel_academico: this.nivel,
					programa: this.programa,
					monto: this.monto,
					facturar: true
				}
				if(this.tipo !== 'cargo-abono') {
					data.monto = this.monto
				}
				const metodo = this.listMetodoPago.find(e => e.id == this.metodoPago)
				if (metodo){
					data.metodo_pago_name =  metodo.text
					data.metodo_pago = metodo.id
				}
				if (this.descuento && this.tipo === 'abierto') {
					const descuento = this.listDescuento.find(e => e.id == this.conceptoDescuento)
					if (descuento) {
						data.descuento = descuento.nombre
						data.descuentos = {
							monto : this.montoDescuento,
							codigo_detalle : this.conceptoDescuento   
						}
					}
				}else{
					data.descuento = ''
					data.descuentos = {
						monto : 0   
					}
				}
				const concepto = this.listConceptos.find(e => e.id == this.concepto)
				if (concepto){
					data.codigo_detalle_name = concepto.nombre
					data.codigo_detalle = concepto.id
				}
				if (this.tipo != 'abierto' && concepto){
					data.regla_cobro = concepto.regla
				/// Este código es para el flujo donde si seleccionaban una insc 3 se les asignaba la INSc2 y 1 en auto	
                // const oldConcepts = this.listConceptos
                //   .filter( e => {
                //     if (vm.tipo === 'servicio' ) {
                //       return e.obligatorio && new Date(e.fecha) < new Date(concepto.fecha) 
                //     } else {
                //       return new Date(e.fecha) < new Date(concepto.fecha)
                //     }
                //   })
                // if (oldConcepts.length){
                //   oldConcepts.forEach(e => {
                //     this.queuePagos.push({
                //       ...data, 
                //       monto: e.monto_cargo,
                //       codigo_detalle_name: e.nombre,
                //       codigo_detalle: e.id,
                //       regla_cobro: e.regla
                //     })
                //   })
                // }
            }
            this.queuePagos.push(data)
			this.getSuma(this.queuePagos)

            // this.fecha = null
            this.monto = null
            // this.autorizacion = null
            // this.metodoPago = ''
           
            this.concepto = '' 
            this.errorFields = []
            if (this.descuento && this.tipo === 'abierto'){
            	this.conceptoDescuento = '' 
            	this.montoDescuento = null
            }
			this.descuento = false

              // this.active = false
          }        
      },
      openLoading() {
      	const loading = this.$vs.loading({
      		target: this.$refs.content,
      	})
      	setTimeout(() => {
      		loading.close()
      	}, 3000)
      },
      async aplicarPagos() {
		this.autorizacion = ''
		this.bloquear = false
		const vm = this
      	vm.loading = vm.$vs.loading()
      	const base = {tipo: this.tipo };
      	const payload = Object.assign(base, {"pagos": this.queuePagos});	

      	try {
      		const { data: response = null } = await cobranza.registrarPago(payload) || {}
      		vm.loading.close()
			this.borrarInfo()
      		if (response && response.errores){
      			const data = response.errores
				let mensajes = Object.values(data)
				if (Array.isArray(mensajes)){
					mensajes.forEach(element => {
						if ( this.checkByType('string', element)){
							this.$vs.notification({
								duration: 5000,
								progress: 'auto',
								color: 'danger',
								position: null,
								title: 'Error',
								text: element 
							})
						}
					});
				}else if (mensaje.descripcion && this.checkByType('string', mensaje)){
					this.$vs.notification({
							duration: 5000,
							progress: 'auto',
							color: 'danger',
							position: null,
							title: 'Error',
							text: mensaje.descripcion 
					})
					
				}else {
					this.$vs.notification({
						progress: 'auto',
						duration: 5000,
						color: 'warn',
						position: null,
						title: 'Warning',
						text: `Algo salió mal pero es posible que se haya registrado tu pago`
					})
				}

      		}else if (response && response.status && response.status == 200){
				  	this.borrarInfo()
				  	vm.loading.close()
      				const data = response.descripcion	
      				this.$vs.notification({
      					progress: 'auto',
      					duration: 5000,
      					color: 'success',
      					position: null,
      					title: 'Éxito',
      					text: data
      				})

      		}else{
      			vm.loading.close()
      			this.$vs.notification({
      				progress: 'auto',
      				duration: 5000,
      				color: 'warn',
      				position: null,
      				title: 'Warning',
      				text: `Algo salió mal pero es posible que se haya registrado tu pago`
      			})
      		}
      		this.queuePagos = []

      		await new Promise(r => setTimeout(r, 100))
      		this.$emit('refreshTable',true)
      		this.active = false
      	} catch (error) {
			vm.loading.close()
			const response = error.response.data
      		if (response && response.errores){
      			const data = response.errores
				let mensajes = Object.values(data)
      			mensajes.forEach(element => {
					if (! this.checkByType('number', element)){
						this.$vs.notification({
							duration: 5000,
							progress: 'auto',
							color: 'danger',
							position: null,
							title: 'Error',
							text: element 
						})
					}
      			});

      		}else{
      			this.$vs.notification({
      				progress: 'auto',
      				duration: 5000,
      				color: 'danger',
      				position: null,
      				title: 'Error',
      				text: `Algo salió mal`
      			})
      		}
			this.queuePagos = []

      		await new Promise(r => setTimeout(r, 100))

      		this.$emit('refreshTable',true)
      		this.active = false
			this.borrarInfo()
      	}      
      },
	  borrarInfo(){
      	this.descuento = false
		this.autorizacion = ''
      	this.fecha = ''
      	this.monto = ''
      	this.metodoPago = ''
      	this.concepto = ''
		this.conceptoDescuento = ''
      	this.montoDescuento = null
	  },
      removerPago(index) {
      	this.queuePagos.splice(index, 1);
      },
      checkByType (type, val) {
      	switch (type) {
      		case 'string':
      		if (val && val.constructor.name === 'String' && val.trim()) {
      			return true
      		}
      		case 'number':
      		if (val && val.constructor.name === 'Number' && val > 0) {
      			return true
      		} 
      		case 'date':
      		if (val && val.constructor.name === 'String' && val.trim()) {
      			const date = new Date(val)
      			if (Object.prototype.toString.call(date) === "[object Date]"){
      				if (!isNaN(date.getTime())){
      					return true
      				}
      			}
      		}
      		case 'array':
      		if (Array.isArray(val) && val.length){
      			return true
      		}
      	}
      	return false
      },
      sanityForm () {
      	let errorFields = []

      	if (!this.checkByType ('date', this.fecha)) {
      		errorFields.push('fecha')
      	}
      	if (!this.checkByType ('string', this.autorizacion)) {
      		errorFields.push('autorizacion')
      	}
      	if (!this.checkByType ('number', this.monto)) {
      		errorFields.push('monto')
      	}
      	if (!this.checkByType ('number', this.concepto)) {
      		errorFields.push('concepto')
      	}
      	if (!this.checkByType ('string', this.metodoPago)) {
      		errorFields.push('metodoPago')
      	}
      	if (this.descuento && this.tipo === 'abierto') {
      		if (!this.checkByType ('number', this.conceptoDescuento)) {
      			errorFields.push('conceptoDescuento')
      		}
      	}
      	if (!this.checkByType ('number', this.programa)) {
      		errorFields.push('programa')
      	}  
      	
      	return errorFields
      },
      async initCatalogs() {
      	if (!this.listMetodoPago.length){
      		try {
      			const { data: metodos } = await catalogos.getMetodosPagos()
      			if (Array.isArray(metodos)){
      				this.listMetodoPago = metodos
      				this.metodoPagoId = (new Date()).getTime()
      			}
      		} catch (error) {
      			console.log(error)
      		}
      	}
      	if (!this.listDescuento.length){
      		try {
      			const { data: descuentos } = await catalogos.getDescuentos()
      			if (Array.isArray(descuentos)){
      				this.listDescuento = descuentos
      				this.conceptoDescuentoId = (new Date()).getTime()
      			}
      		} catch (error) {
      			console.log(error)
      		}
      	}
      	
      	
      	await this.getConcepto()
      },
      async getConcepto() {
		this.loadingConceptos = true
      	if(this.tipo !== 'cargo-abono'){
      		if(this.programa !== '' && this.cicloEscolar !== '' && this.tipo !== ''){
      			let params = {
      				programa : this.programa,
      				institucion: this.institucion,
      				ciclo_escolar: this.cicloEscolar,
      				tipo: this.tipo,
      				persona: this.personaId,
      			}
      			const response = await cobranza.getConceptos(params) || {}
      			this.concepto = ''
      			this.listConceptos = response.data

				this.loadingConceptos = false
      			if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
      				this.noConceptos = false

					this.loadingConceptos = false
      			}else {
      				this.noConceptos = true

					this.loadingConceptos = false
      			}
      		}
      	} else if(this.tipo === 'cargo-abono'){
      		if(this.programa !== '' && this.cicloEscolar !== '' && this.tipo !== ''){
      			let params = {
      				programa : this.programa,
      				institucion: this.institucion,
      				ciclo_escolar: this.cicloEscolar,
      				tipo: 'cargo-abono',
      				persona: this.personaId,
      				fecha: this.fecha
      			}
      			const response = await cobranza.getConceptos(params) || {}
      			this.listConceptos = response.data

				this.loadingConceptos = false
      			this.concepto = ''
      			this.monto = ''

      			if (this.listConceptos && this.listConceptos.length && this.listConceptos.length >0 ){
      				this.noConceptos = false

					this.loadingConceptos = false
      			}else {
      				this.noConceptos = true

					this.loadingConceptos = false
      			}
      		}

      	}
      	this.conceptoId = (new Date()).getTime()
      },
      getMonto() {
      	if(this.tipo !== 'abierto' ){
      		const monto = this.listConceptos
      		monto.forEach(i => {
      			if(i.id === this.concepto){
      				this.monto = i.monto_cargo
      			}
      		})
      	}
      }
  },
  watch: {
	async programaDefault(){
		this.programa = this.programaDefault
	},
  	async programa(val){
  		await this.getConcepto()
  	},
  	value (val) {
  		this.active = val
  	},
  	concepto(val){
  		if (this.tipo !== 'abierto') {
              
              this.getMonto()
          }
    },
      async active (val) {
      	await this.initCatalogs()
      	if (!val){
      		this.$emit('input', val);
      	}
      },
      async tipo (val) {
      	this.descuento = false
      	this.fecha = ''
      	this.monto = ''
      	this.montoDescuento = null
      	this.metodoPago = ''
      	this.concepto = ''
      	this.queuePagos = []
      	this.errorFields = []
      	this.listConceptos = []
		this.autorizacion = ''
		this.conceptoDescuento = ''
      }
  }
}
</script>

<style lang="scss"  scoped >
$breakpoint-tablet: 767px;
.color-blue {
	background-color: #005aa3;
}

.dividerLine {
	width: 100%;
	border-bottom: 1px solid #ddd
}

.greyColor {
	color: gray
}

.greyOscuro {
	color: rgb(78, 78, 78);
	font-weight: bold;
}

.marginTop{
	@media only screen and (max-width: $breakpoint-tablet) {
		margin-top: 1rem;
	}
}

.textRight{
	@media only screen and (max-width: $breakpoint-tablet) {
		text-align: right;
	}
	@media only screen and (min-width: $breakpoint-tablet) {
		text-align: center;
	}
}
.textRightDesktop{
	@media only screen and (min-width: $breakpoint-tablet) {
		text-align: right;
	}
}
</style>

<style>
.labelInput{
	margin-bottom: 6px !important;
	padding: 0px 11px 0px 11px;
	font-size: 12px;
}

.dangerColor{
	color: red;
	font-size: 18px;
}
</style>